var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SpinnerLoading bb-fcenter"},[_c('div',{staticClass:"bb-loading --orange",class:{ '--large': _vm.large, '--medium': _vm.medium, 'bb-mb-9': _vm.marginBottom }})])
}
var staticRenderFns = []

export { render, staticRenderFns }